import { apiPaths, getApiPath, httpStatus } from '../../../constants'
import { Api } from '../../../middlewares'
import { Logger, LoggerTypes } from '../../../utils'

// -- GET
export const GET_SCENARIO_RESOURCES_SUCCESS = 'GET_SCENARIO_RESOURCES_SUCCESS'
export const GET_SCENARIO_RESOURCES_FAILURE = 'GET_SCENARIO_RESOURCES_FAILURE'

// -- CREATE
export const CREATE_SCENARIO_RESOURCE_SUCCESS = 'CREATE_SCENARIO_RESOURCE_SUCCESS'
export const CREATE_SCENARIO_RESOURCE_FAILURE = 'CREATE_SCENARIO_RESOURCE_FAILURE'

// -- UPDATE
export const UPDATE_SCENARIO_RESOURCE_SUCCESS = 'UPDATE_SCENARIO_RESOURCE_SUCCESS'
export const UPDATE_SCENARIO_RESOURCE_FAILURE = 'UPDATE_SCENARIO_RESOURCE_FAILURE'

// -- DELETE
export const DELETE_SCENARIO_RESOURCE_SUCCESS = 'DELETE_SCENARIO_RESOURCE_SUCCESS'
export const DELETE_SCENARIO_RESOURCE_FAILURE = 'DELETE_SCENARIO_RESOURCE_FAILURE'

// -- SEARCH
export const SEARCH_SCENARIO_RESOURCES = 'SEARCH_SCENARIO_RESOURCES'

// -----------------------------------------------------------------------------

/**
 * SEARCH for a scenario's resource's attribute based on its name.
 *
 * @param {string} terms Text to be searched within the scenario resource.
 * @returns {Promise<array<object>>}
 */
export const searchScenarioResources = (terms) => async (dispatch) => {
  dispatch({
    type: SEARCH_SCENARIO_RESOURCES,
    data: terms
  })
}

/**
 * GET the list of all the resources that belong to a specific scenario.
 *
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {Promise<array<object>>}
 */
export const getScenarioResources = (pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_RESOURCE_LIST, { pid, sid })
  const api = new Api(path)
  const result = await api.get()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] resourcesActions.getScenarioResources()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: GET_SCENARIO_RESOURCES_SUCCESS,
      data: result.data.items || []
    })
  }
  return dispatch({
    type: GET_SCENARIO_RESOURCES_FAILURE,
    data: result.data
  })
}

/**
 * CREATE a scenario resource.
 *
 * @param {object} newResource New resource to be created.
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {object}
 */
export const createScenarioResource = (newResource, pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_RESOURCE_CREATE, { pid, sid })
  const api = new Api(path)
  const result = await api.create(newResource)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] resourcesActions.createScenarioResource()', { path, newResource, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: CREATE_SCENARIO_RESOURCE_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: CREATE_SCENARIO_RESOURCE_FAILURE,
    data: result.data
  })
}

/**
 * UPDATE a specific scenario resource attribute.
 *
 * @param {object} newResource Resource object that will replace the previous one.
 * @param {uuid} rid Scenario resource ID.
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {Promise<object>}
 */
export const updateScenarioResource = (newResource, rid, pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_RESOURCE_UPDATE, { pid, sid, rid })
  const api = new Api(path)
  const result = await api.update(newResource)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] resourcesActions.updateScenarioResource()', { path, newResource, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_SCENARIO_RESOURCE_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_SCENARIO_RESOURCE_FAILURE,
    data: result.data
  })
}

/**
 * DELETE a specific scenario resource.
 *
 * @param {uuid} rid Scenario resource ID.
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {Promise<object>}
 */
export const deleteScenarioResource = (rid, pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_RESOURCE_DELETE, { pid, rid, sid })
  const api = new Api(path)
  const result = await api.delete()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] resourcesActions.deleteScenarioResource()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: DELETE_SCENARIO_RESOURCE_SUCCESS,
      data: rid
    })
  }
  return dispatch({
    type: DELETE_SCENARIO_RESOURCE_FAILURE,
    data: result.data
  })
}
